import { StreamingUpdateData } from './responses-types.ts';

/**
 * Parses a raw SSE data line and fires the appropriate StreamingUpdateData event.
 * Matches the theta-assist SSE parsing pattern, adapted for Pages' event format.
 *
 * Pages backend wraps all events under `event: update` with the Responses API
 * event type embedded in the JSON `type` field. The special terminal signals
 * `[DONE]` and `[ERROR]` arrive as bare data lines.
 */
const handleServerSideEvents = (
    line: string,
    onEvent: (update: StreamingUpdateData) => void
): void => {
    if (!line.startsWith('data: ')) return;

    const payload = line.slice(6);

    if (payload === '[DONE]') {
        onEvent({ type: 'done' });
        return;
    }

    if (payload === '[ERROR]') {
        onEvent({ type: 'error' });
        return;
    }

    try {
        const event = JSON.parse(payload) as StreamingUpdateData;
        if (event?.type) {
            onEvent(event);
        }
    } catch (error) {
        console.error('Error parsing SSE JSON:', error, payload);
    }
};

export default handleServerSideEvents;
